// extracted by mini-css-extract-plugin
export default {"div":"NewsCatalogue_div__pxpwk","card":"NewsCatalogue_card__bFReM","cards":"NewsCatalogue_cards__aw29Q"};